import { useEffect, useState } from "react";
import { AccountType } from "../../components/constants/constants";

export default function SubmitTestOnLeave(
  isReview,
  data,
  creatQuizDataAndSave,
  assessmentStarted
) {
  const [issubmitquiz, setissubmitquiz] = useState(false);

  useEffect(() => {    
    if (isReview === undefined && data.user_type === AccountType.STUDENT && (assessmentStarted || data?.status !== "New")) {
        window.addEventListener('pagehide', handlePageleave);
        // window.addEventListener('popstate', handlePageleave);
    
        return () => {
          window.removeEventListener('pagehide', handlePageleave);
        };
    }
  });

  const handlePageleave = (event) => {    
    if (event.persisted && !issubmitquiz) {
        creatQuizDataAndSave();
        setissubmitquiz(true);
        localStorage.setItem("task_submit_id",data?.student_assessment_id);
    }
  }
}
